import { AsyncRequest } from 'angieslist-app-platform';

export default {
  ...AsyncRequest.createActionKeys('GET_SP_ADDRESSES'),
};



// WEBPACK FOOTER //
// ./src/modules/store/common/addressesActionKeys.js